module.exports = __webpack_public_path__ + "img/icono-pdf.82f139cb.svg";